<template>
    <div class="page center-wallet-page py-lg-6">
        <v-container :class="{'white px-0': phoneOnly}">
            <transition name="fade" appear>
                <div v-if="wallet">
                    <v-row :class="{'mx-0': phoneOnly}">
                        <v-col cols="12" lg="4" :class="{'px-0': phoneOnly}">
                            <div :style="pcOnly ? 'position: sticky; top: 85px;' : ''">
                                <v-card flat class="wallet-widget pa-lg-2 lg:bordered rounded-lg">
                                    <!-- <v-card-title class="title strong-text--text pt-lg-2">
                                        <v-icon color="strong-text" class="me-2">mdi-wallet-outline</v-icon>
                                        مدفوعات السنتر
                                    </v-card-title>
                                    <v-divider class="mx-4" style="opacity: 0.6"></v-divider> -->

                                    <v-card-text class="text--text">
                                        <div class="d-flex align-center justify-space-between">
                                            <div class="balance-wrapper flex-grow-1 pe-3 text-right">
                                                <div v-if="wallet.balance > 0" class="medium-text muted--text mb-3">الرصيد الحالي</div>
                                                <div v-else class="medium-text muted--text mb-3">مبلغ مطلوب سداده</div>
                                                <div class="balance mb-4">
                                                    <span :class="wallet.balance < 0 ? 'error--text text--darken-1' : 'strong-text--text'">
                                                        {{moneyFormat(wallet.balance, false)}}
                                                    </span>
                                                </div>
                                                <div class="d-flex flex-wrap justify-start" style="gap: 8px;">
                                                    <v-chip
                                                        v-if="subscriptionTypeLabel"
                                                        small
                                                        label
                                                        outlined
                                                        color="primary"
                                                        class="medium-text"
                                                    >
                                                        <v-icon left size="16">mdi-calendar-month-outline</v-icon>
                                                        {{subscriptionTypeLabel}}
                                                    </v-chip>
                                                    <v-chip
                                                        v-if="wallet.discount_percent"
                                                        small
                                                        label
                                                        color="success"
                                                        class="medium-text"
                                                    >
                                                        <v-icon left size="16">mdi-percent-outline</v-icon>
                                                        {{wallet.discount_percent}} خصم عام
                                                    </v-chip>
                                                </div>
                                            </div>
                                            <div
                                                v-if="displayUser && displayUser.profile_qr_code"
                                                class="qr-header e-link flex-shrink-0"
                                                @click="qrcodeDialog = true"
                                            >
                                                <qrcode :value="displayUser.profile_qr_code" :width="phoneOnly ? 130 : 140" />
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>

                                <v-card
                                    v-if="displayUser && userInfoItems.length"
                                    flat
                                    class="mt-3 pa-lg-2 lg:bordered rounded-lg"
                                >
                                    <v-card-text class="text--text py-0 px-md-2">
                                        <div class="user-info-wrapper d-flex align-center">
                                            <v-avatar
                                                :size="phoneOnly ? 100 : 110"
                                                rounded
                                                class="bordered user-info-avatar flex-shrink-0"
                                            >
                                                <v-img v-if="displayUser.avatar" :src="displayUser.avatar"></v-img>
                                                <v-icon v-else size="36" color="muted">mdi-account</v-icon>
                                            </v-avatar>
                                            <div class="user-info-card flex-grow-1">
                                                <div
                                                    v-for="(item, index) in userInfoItems"
                                                    :key="item.label"
                                                    class="user-info-row"
                                                    :class="{'user-info-row--border': index < userInfoItems.length - 1}"
                                                >
                                                    <div class="user-info-label">{{item.label}}</div>
                                                    <div class="user-info-value" :class="item.valueClass">{{item.value}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="8" :class="{'px-0': phoneOnly}">
                            <v-divider v-if="phoneOnly" class="my-2 mx-4"></v-divider>

                            <v-card flat :class="{'bordered pa-1 rounded-lg': pcOnly}">
                                <v-card-title class="strong-text--text mb-2">
                                    <v-icon size="26" color="strong-text">mdi-order-bool-descending-variant</v-icon>
                                    <span class="ms-2">سجل العمليات</span>
                                </v-card-title>
                                <v-card-text>
                                    <div v-if="transactions && transactions.length">
                                        <v-simple-table class="e-data-table">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-right font-weight-medium">
                                                            تفاصيل العملية
                                                        </th>
                                                        <th class="text-center font-weight-medium">
                                                            المبلغ
                                                        </th>
                                                        <th class="text-left font-weight-medium">
                                                            وقت العملية
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(transaction, index) in transactions"
                                                        :key="transactionKey(transaction, index)"
                                                        style="white-space: nowrap!important;"
                                                    >
                                                        <td class="strong-text--text text-right">
                                                            <div class="details-text d-flex align-center">
                                                                <v-icon :color="transactionIconColor(transaction.type)" size="20" class="me-2">
                                                                    {{transactionIcon(transaction.type)}}
                                                                </v-icon>
                                                                <div>
                                                                    <span>{{transactionLabel(transaction)}}</span>
                                                                    <span
                                                                        v-if="transactionResourceName(transaction)"
                                                                        class="details-text muted--text"
                                                                    >
                                                                        {{' ' + stringLimit(transactionResourceName(transaction), 50)}}
                                                                    </span>
                                                                    <div
                                                                        v-if="transaction.discount_percent || transaction.discount_percent === 0"
                                                                        class="small-text text--text mt-1"
                                                                    >
                                                                        مطبق خصم <strong>{{transaction.discount_percent}} <span style="font-family: 'open sans'">%</span></strong>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 18px" class="text-center">
                                                            <span v-if="transaction.value >= 0" class="strong-text--text text--darken-1">
                                                                + {{moneyFormat(transaction.value)}}
                                                            </span>
                                                            <span v-else class="error--text text--darken-1">
                                                                - {{moneyFormat(-1 * transaction.value)}}
                                                            </span>

                                                            <!-- <v-tooltip color="tooltip" transition="fade-transition" bottom>
                                                                <template v-slot:activator="{on, attrs}">
                                                                    <v-chip
                                                                        label
                                                                        small
                                                                        class="px-1 ms-2 bordered"
                                                                        style="height: 18px"
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        color="transparent"
                                                                    >
                                                                        <span
                                                                            v-if="transaction.balance_after || transaction.balance_after === 0"
                                                                            class="x-small-text muted--text"
                                                                        >
                                                                            <v-icon color="muted" size="13">mdi-wallet-outline</v-icon>
                                                                            {{moneyFormat(transaction.balance_after)}}
                                                                        </span>
                                                                    </v-chip>
                                                                </template>
                                                                <span>رصيد المحفظة بعد العملية</span>
                                                            </v-tooltip> -->
                                                        </td>
                                                        <td class="text-left ltr-dir">
                                                            {{dateTimeFormat(transaction.timestamp, true)}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                        <v-btn
                                            v-if="transactionsNext"
                                            block
                                            text
                                            color="primary"
                                            class="mt-3 surface2"
                                            v-ripple="phoneOnly"
                                            :loading="loadingMore"
                                            :disabled="loadingMore"
                                            @click="loadMoreTransactions"
                                        >
                                            تحميل المزيد من العمليات...
                                        </v-btn>
                                    </div>
                                    <div v-else>
                                        <v-alert type="info" dense color="blue-grey" text class="mb-0">
                                            <div class="details-text">لم يتم العثور على عمليات</div>
                                        </v-alert>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <div v-else-if="notFound && !loading">
                    <v-alert type="info" dense color="blue-grey" text class="ma-4">
                        <div class="details-text">لم يتم العثور على مدفوعات السنتر</div>
                    </v-alert>
                </div>
            </transition>
        </v-container>

        <v-dialog v-model="qrcodeDialog" max-width="275" overlay-color="#000" overlay-opacity="0.65">
            <v-card v-if="displayUser && displayUser.profile_qr_code">
                <v-card-text class="pa-3 d-flex align-center justify-center flex-column">
                    <qrcode :value="displayUser.profile_qr_code" />
                    <div v-if="displayUser.center_name" class="mt-2">
                        <v-chip color="primary" outlined label small class="medium-text">
                            {{displayUser.center_name}}
                        </v-chip>
                    </div>
                    <div v-if="displayUser.center_id" class="mt-2 strong-text--text font-weight-bold">
                        {{displayUser.center_id}}
                    </div>
                    <v-btn absolute top left icon @click="qrcodeDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Qrcode from '@/components/default/qrcode'

export default {
    name: 'CenterWallet',
    components: {
        Qrcode,
    },
    data(){
        return {
            loading: false,
            loadingMore: false,
            wallet: null,
            transactions: null,
            transactionsNext: null,
            notFound: false,
            profileUser: null,
            qrcodeDialog: false,
        }
    },
    computed: {
        ...GlobalComputed,
        displayUser(){
            return this.profileUser || this.user;
        },
        userInfoItems(){
            const user = this.displayUser;
            if (!user) return [];
            const items = [
                {label: 'اسم الطالب', value: user.name},
            ];
            if (user.center_name) {
                items.push({label: 'السنتر', value: user.center_name});
            }
            if (user.center_id) {
                items.push({label: 'ID السنتر', value: user.center_id, valueClass: 'primary--text'});
            }
            if (user.phone) {
                items.push({label: 'رقم الهاتف', value: user.phone, valueClass: 'ltr-dir'});
            }
            return items.filter(item => !!item.value);
        },
        subscriptionTypeLabel(){
            if (!this.wallet || !this.wallet.subscription_type) return null;
            if (this.wallet.subscription_type === 'monthly') return 'اشتراك شهري';
            if (this.wallet.subscription_type === 'lecture') return 'الدفع بالمحاضرة';
            return null;
        },
    },
    methods: {
        loadProfileUser(){
            return this.$store.dispatch('fastGetAction', {url: '/profile'}).then(response=>{
                this.profileUser = response.data.user;
            }).catch(()=>{});
        },
        transactionKey(transaction, index){
            return `${transaction.timestamp || transaction.created_at || 'tx'}-${index}`;
        },
        transactionIcon(type){
            const icons = {
                monthly_subscription_deduction: 'mdi-calendar',
                monthly_subscription: 'mdi-calendar-check',
                lecture_paid_value: 'mdi-cash-check',
                lecture_deduction: 'mdi-clipboard-minus-outline',
                admin_balance_update: 'mdi-help-circle',
            };
            return icons[type] || 'mdi-swap-horizontal';
        },
        transactionIconColor(type){
            const colors = {
                monthly_subscription_deduction: 'error darken-1',
                monthly_subscription: 'success darken-1',
                lecture_paid_value: 'success darken-1',
                lecture_deduction: 'secondary',
                admin_balance_update: 'secondary',
            };
            return colors[type] || 'muted';
        },
        transactionResourceName(transaction){
            if (!transaction) return null;
            if (transaction.type === 'monthly_subscription_deduction' || transaction.type === 'monthly_subscription'){
                const monthName = transaction.center_month && transaction.center_month.name
                    ? `[ ${transaction.center_month.name} ]`
                    : null;
                const examName = transaction.local_exam_resource && transaction.local_exam_resource.name
                    ? transaction.local_exam_resource.name
                    : null;
                if (monthName && examName) return `${monthName} - ${examName}`;
                return monthName || examName;
            }
            if (transaction.type === 'lecture_paid_value' || transaction.type === 'lecture_deduction'){
                return transaction.local_exam_resource && transaction.local_exam_resource.name
                    ? transaction.local_exam_resource.name
                    : null;
            }
            return null;
        },
        transactionLabel(transaction){
            if (!transaction) return '';
            switch (transaction.type) {
                case 'monthly_subscription_deduction':
                    return 'مطلوب دفع قيمة الاشتراك الشهري';
                case 'monthly_subscription':
                    return 'تم سداد قيمة الاشتراك الشهري';
                case 'lecture_paid_value':
                    return 'المبلغ الذي تم تحصيله عند دخول محاضرة سنتر';
                case 'lecture_deduction':
                    return 'مطلوب دفع قيمة محاضرة السنتر';
                case 'admin_balance_update':
                    return transaction.comment || 'تعديل رصيد بواسطة الإدارة';
                default:
                    return transaction.comment || 'عملية على مدفوعات السنتر';
            }
        },
        loadCenterWalletData(moreTransactions=false){
            if (this.loading || this.loadingMore) return;

            if (moreTransactions) {
                this.loadingMore = true;
            } else {
                this.loading = true;
                this.setLinearLoading(true);
            }

            const payload = {};
            if (moreTransactions) {
                payload.url = this.transactionsNext;
            }

            this.$store.dispatch('loadCenterWalletData', payload).then(response=>{
                this.notFound = false;
                this.wallet = response.data.wallet;
                const pageTransactions = response.data.transactions && response.data.transactions.data
                    ? response.data.transactions.data
                    : [];

                if (moreTransactions) {
                    this.transactions.push(...pageTransactions);
                } else {
                    this.transactions = pageTransactions;
                }

                this.transactionsNext = response.data.transactions && response.data.transactions.links
                    ? response.data.transactions.links.next
                    : null;
            }).catch(error=>{
                const status = error && error.response ? error.response.status : null;
                if (status === 404 && !moreTransactions) {
                    this.wallet = null;
                    this.transactions = [];
                    this.transactionsNext = null;
                    this.notFound = true;
                } else {
                    this.showMsg('حدثت مشكلة أثناء تحميل بيانات مدفوعات السنتر');
                }
            }).finally(()=>{
                this.loading = false;
                this.loadingMore = false;
                this.setLinearLoading(false);
            });
        },
        loadMoreTransactions(){
            this.loadCenterWalletData(true);
        },
        ...GlobalMethods,
    },
    mounted(){
        if (this.appData && this.appData.enable_student_center_wallet_section){
            this.loadProfileUser();
            this.loadCenterWalletData();
            this.scrollToTop();
        } else {
            this.$router.push('/not-found');
        }
    }
};
</script>
<style lang="scss" scoped>
.wallet-widget{
    .balance{
        font-size: 2rem;
        font-weight: 500;
    }
}
.user-info-wrapper{
    gap: 14px;
}
.user-info-avatar{
    border-radius: 16px !important;
}
.user-info-card{
    padding: 4px 8px;
    min-width: 0;
}
.user-info-row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 6px 0;
    &--border{
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    }
}
.user-info-label{
    color: rgba(0, 0, 0, 0.45);
    font-size: 0.8rem;
    flex-shrink: 0;
}
.user-info-value{
    color: rgba(0, 0, 0, 0.87);
    font-weight: 500;
    font-size: 0.95rem;
    text-align: left;
    word-break: break-word;
}
</style>
